import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f7a1b8e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6f7a1b8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a1b8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7a1b8e')) {
      api.createRecord('6f7a1b8e', component.options)
    } else {
      api.reload('6f7a1b8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6f7a1b8e&scoped=true", function () {
      api.rerender('6f7a1b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/biddingPlanWitnessHis/index.vue"
export default component.exports